import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { TextInputControl } from 'components/_basic/Form/TextInput';
import { FormHeader } from 'components/_basic/FormHeader/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';

import { concatWithDot } from 'helpers/string';

import { GLOBAL_FIELD_NAMES, globalPrefix } from '../../Global/form';

export const GoalsExecSummary: React.FC = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.EXECUTIVE_SUMMARY,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_EXECUTIVE_SUMMARY.GOALS_AND_OBJECTIVES,
  );

  return (
    <>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader
          locked={!canAccess}
          title={t('executiveSummary.title')}
          badgeText={t('executiveSummary.goalsAndObjectives.title')}
          section={FOR_BANK_SECTIONS.EXECUTIVE_SUMMARY}
        />
      </FormSectionCard>
      {/* 1.1.1 */}
      <FormSectionCard
        title={t('executiveSummary.goalsAndObjectives.mainGoals')}
        aiFieldName={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.MAIN_GOALS)}
      >
        <TextInputControl
          multiline
          control={control}
          id="executiveSummary.goalsAndObjectives.mainGoals"
          name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.MAIN_GOALS)}
          minRows={4}
          disabled={!canAccess}
          maxLength={1000}
        />
      </FormSectionCard>
      {/* 1.1.2 */}
      <FormSectionCard
        disabled={!canAccess}
        title={t('executiveSummary.goalsAndObjectives.briefProjectDescription')}
        aiFieldName={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.PROJECT_BRIEF_DESCRIPTION)}
        aiOnlyUpdate
      >
        <TextInputControl
          multiline
          control={control}
          id="executiveSummary.goalsAndObjectives.briefProjectDescription"
          name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.PROJECT_BRIEF_DESCRIPTION)}
          minRows={4}
          disabled={!canAccess}
          maxLength={1000}
        />
      </FormSectionCard>
      {/* 1.1.3 */}
      <FormSectionCard
        disabled={!canAccess}
        title={t('executiveSummary.goalsAndObjectives.strategy')}
        aiFieldName={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.STRATEGY_FOR_ACHIEVING_GOALS)}
      >
        <TextInputControl
          multiline
          control={control}
          id="executiveSummary.goalsAndObjectives.strategy"
          name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.STRATEGY_FOR_ACHIEVING_GOALS)}
          minRows={4}
          disabled={!canAccess}
          maxLength={1000}
        />
      </FormSectionCard>
    </>
  );
};
